module.exports = __webpack_public_path__ + "media/images/places/img_engagement-location-photo-d874d0c0b8111854a2666673f79fe2e4.jpg";